export default "__VITE_ASSET__DCFT9doP__"